package com.essntl.features.profile.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [ProfileSupabaseDataSource::class])
internal class ProfileSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<ProfileDto> {
    override val tableName: String = "profiles"
}
